import * as React from "react";
import { Coordinates, EllipseCoordinates } from "../../../api/patientScans";

interface PelvicLymphNodeMetastasesImageProps {
  metastases: { [key: string]: Coordinates | EllipseCoordinates };
  onPointerMove: (event: React.PointerEvent) => void;
  onPointerLeave: () => void;
  onLymphNodeClick: React.MouseEventHandler<SVGSVGElement>;
  onMetastasisClick: React.MouseEventHandler<SVGCircleElement>;
  onContextMenu: React.MouseEventHandler<SVGCircleElement>;
  markerColor: string;
}

const PelvicLymphNodeMetastasesImage = React.forwardRef<
  SVGSVGElement,
  PelvicLymphNodeMetastasesImageProps
>(
  (
    {
      metastases,
      onMetastasisClick,
      onLymphNodeClick,
      onPointerMove,
      onPointerLeave,
      onContextMenu,
      markerColor,
    },
    ref
  ) => (
    <svg
      id="PelvicLymphNodeMetastasesImage"
      ref={ref}
      viewBox="0 0 1024 768"
      width="100%"
      height="100%"
      fill="none"
      style={{ maxHeight: "77vh" }}
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
      onClick={onLymphNodeClick}
    >
      <g id="Local Lesions SVG">
        <rect width={1024} height={768} fill="white" />
        <g id="Group 76">
          <mask
            id="mask0_PELVICLYMPHNODE"
            style={{
              maskType: "alpha",
            }}
            maskUnits="userSpaceOnUse"
            x={166}
            y={38}
            width={692}
            height={692}
          >
            <path
              id="Subtract"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M512 730C703.091 730 858 575.091 858 384C858 192.909 703.091 38 512 38C320.909 38 166 192.909 166 384C166 575.091 320.909 730 512 730ZM475.05 313.362C470.632 313.362 467.05 316.944 467.05 321.362V438.504C467.05 442.922 470.632 446.504 475.05 446.504H548.16C552.579 446.504 556.16 442.922 556.16 438.504V321.362C556.16 316.944 552.579 313.362 548.16 313.362H475.05ZM693.795 336.749C692.384 332.562 687.882 330.413 683.739 331.948L651.929 343.736C647.786 345.271 645.572 349.909 646.983 354.096L678.387 447.271C679.799 451.458 684.301 453.608 688.444 452.072L720.254 440.285C724.397 438.749 726.611 434.111 725.2 429.924L693.795 336.749ZM340.261 331.948C336.118 330.413 331.616 332.562 330.205 336.749L298.8 429.924C297.389 434.111 299.603 438.749 303.746 440.285L335.556 452.072C339.699 453.608 344.201 451.458 345.613 447.271L377.017 354.096C378.428 349.909 376.214 345.271 372.071 343.736L340.261 331.948ZM387.374 479.666C387.374 475.248 390.955 471.666 395.374 471.666H462.194C466.612 471.666 470.194 475.248 470.194 479.666V530.761C470.194 535.179 466.612 538.761 462.194 538.761H395.374C390.955 538.761 387.374 535.179 387.374 530.761V479.666ZM628.859 471.12C633.278 471.12 636.859 474.702 636.859 479.12V530.215C636.859 534.633 633.278 538.215 628.859 538.215H559.942C555.524 538.215 551.942 534.633 551.942 530.215V479.12C551.942 474.702 555.524 471.12 559.942 471.12H628.859ZM642.29 378.068C643.038 373.714 640.125 369.519 635.783 368.699L614.512 364.683C610.17 363.863 606.045 366.729 605.297 371.083L592.356 446.437C591.609 450.791 594.522 454.986 598.863 455.806L620.135 459.822C624.477 460.642 628.602 457.776 629.35 453.421L642.29 378.068ZM388.086 368.699C383.744 369.519 380.831 373.714 381.579 378.068L394.519 453.421C395.267 457.776 399.393 460.642 403.734 459.822L425.006 455.806C429.347 454.986 432.261 450.791 431.513 446.437L418.572 371.083C417.825 366.729 413.699 363.863 409.357 364.683L388.086 368.699Z"
              fill="#F6F6F6"
            />
          </mask>
          <g mask="url(#mask0_PELVICLYMPHNODE)">
            <g id="Group 75">
              <rect
                id="Rectangle 39"
                x={342.294}
                y={517.544}
                width={390.621}
                height={225.358}
                fill="#FCFCFC"
              />
              <g id="Vector" filter="url(#filter0_f_PELVICLYMPHNODE)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M839.912 203.68C903.545 470.9 845.724 671.447 848.035 687.901C849.258 696.597 704.56 853.001 603.865 769.851C563.704 736.688 576.012 568.757 513.467 532.172C459.626 557.5 466.148 777.4 413.459 810.098C314.281 871.646 177.781 698.444 178.897 690.499C181.21 674.046 119.308 470.9 182.94 203.68C193.83 157.95 209.399 58.9818 230.74 -56C230.74 -56 774.559 -52.4561 773.582 -56C794.981 21.4896 817.084 107.813 839.912 203.68Z"
                  fill="#F6F6F6"
                />
              </g>
              <g id="Group 20" filter="url(#filter1_f_PELVICLYMPHNODE)">
                <path
                  id="Vector_2"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M296.407 321.606C296.407 321.606 334.871 381.489 293.61 406.717C293.61 406.717 232.083 377.76 215.54 449.093C207.937 481.833 247.784 481.004 271.501 617.869L279.84 666.252L350.307 669.931C350.307 669.931 310.112 583.626 322.662 528.093C335.206 472.56 331.761 446.14 378.835 440.13C378.835 440.13 348.711 354.864 296.407 321.606Z"
                  fill="#B1B1B1"
                  fillOpacity={0.14}
                />
                <path
                  id="Vector_3"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M741.093 321.606C741.093 321.606 703.065 381.489 743.859 406.717C743.859 406.717 804.689 377.76 821.045 449.093C828.562 481.833 789.166 481.004 765.718 617.869L757.473 666.252L687.804 669.931C687.804 669.931 727.544 583.626 715.136 528.093C702.733 472.56 706.14 446.14 659.599 440.13C659.599 440.13 689.382 354.864 741.093 321.606Z"
                  fill="#B1B1B1"
                  fillOpacity={0.14}
                />
                <g id="Group">
                  <path
                    id="Vector_4"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M406.326 398.425C406.326 398.425 449.949 435.342 488.842 422.364C513.807 414.04 514.938 474.689 480.537 497.181C446.135 519.672 434.206 506.642 411.353 499.869C361.839 485.185 406.326 398.425 406.326 398.425Z"
                    fill="#B1B1B1"
                    fillOpacity={0.14}
                  />
                </g>
                <g id="Group_2">
                  <path
                    id="Vector_5"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M629.384 398.423C629.384 398.423 585.76 435.34 546.867 422.362C521.903 414.038 520.771 474.687 555.173 497.179C589.575 519.67 601.503 506.64 624.356 499.867C673.871 485.183 629.384 398.423 629.384 398.423Z"
                    fill="#B1B1B1"
                    fillOpacity={0.14}
                  />
                </g>
                <g id="Group_3">
                  <path
                    id="Vector_6"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M310.086 367.552C310.086 367.552 288.481 319.31 250.795 283.324C213.115 247.338 252.119 99.3074 377.874 153.907C503.623 208.559 427.015 292.113 409.109 329.702C391.202 367.292 403.877 356.176 410.188 391.903C416.499 427.631 384.448 481.041 462.181 507.566C462.181 507.566 397.793 536.78 377.874 463.308C357.949 389.836 337.086 388.802 310.086 367.552Z"
                    fill="#B1B1B1"
                    fillOpacity={0.14}
                  />
                </g>
                <g id="Group_4">
                  <path
                    id="Vector_7"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M725.623 367.552C725.623 367.552 747.227 319.31 784.913 283.324C822.593 247.338 783.589 99.3074 657.834 153.907C532.084 208.559 608.692 292.113 626.599 329.702C644.506 367.292 631.831 356.176 625.52 391.903C619.209 427.631 651.26 481.041 573.526 507.566C573.526 507.566 637.915 536.78 657.834 463.308C677.759 389.836 698.623 388.802 725.623 367.552Z"
                    fill="#B1B1B1"
                    fillOpacity={0.14}
                  />
                </g>
              </g>
              <g id="Group 18" filter="url(#filter2_f_PELVICLYMPHNODE)">
                <g id="Group 66">
                  <path
                    id="Union"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M518.287 -16.4317C515.295 -18.6704 511.58 -19.9962 507.556 -19.9962C497.653 -19.9962 489.626 -11.9685 489.626 -2.06594C489.626 78.358 482.734 126.985 469.601 162.524C456.669 197.522 437.185 221.265 408.308 251.389C401.27 258.731 394.197 266.425 387.188 274.533C385.84 275.695 384.655 277.068 383.689 278.622C354.42 313.186 326.579 355.201 307.539 409.192C283.19 478.237 273.692 565.549 292.298 680.081C293.885 689.856 303.096 696.492 312.871 694.905C322.645 693.317 329.282 684.106 327.694 674.331C309.887 564.716 319.323 483.601 341.358 421.118C351.13 393.407 363.471 369.101 377.291 347.384C379.232 362.221 382.792 375.736 386.833 385.105C390.754 394.199 401.304 398.391 410.397 394.47C419.49 390.549 423.683 379.999 419.762 370.906C416.888 364.24 413.502 351.497 412.165 336.528C410.957 322.994 411.564 309.126 414.802 297.426C421.197 290.05 427.686 282.995 434.195 276.205C464.029 245.084 487.697 217.016 503.239 174.953C510.074 156.456 515.235 135.544 518.856 110.806C522.381 132.076 527.147 151.064 533.233 168.427C548.564 212.157 571.849 244.357 602.379 276.205C608.237 282.316 614.079 288.641 619.851 295.222C623.323 307.484 624.005 322.289 622.821 336.649C621.578 351.735 618.428 364.602 615.732 371.375C612.07 380.575 616.56 391.003 625.761 394.665C634.961 398.327 645.388 393.837 649.05 384.637C652.896 374.975 656.276 360.834 657.999 345.381C672.339 367.604 685.142 392.552 695.216 421.118C717.251 483.601 726.687 564.716 708.88 674.331C707.292 684.106 713.929 693.317 723.703 694.905C733.478 696.492 742.689 689.856 744.277 680.081C762.883 565.549 753.385 478.237 729.035 409.192C704.694 340.17 665.97 290.721 628.266 251.389C600.086 221.993 580.218 194.055 567.075 156.563C553.785 118.654 546.948 69.7729 546.948 -2.06594C546.948 -11.9685 538.921 -19.9962 529.018 -19.9962C524.994 -19.9962 521.279 -18.6704 518.287 -16.4317Z"
                    fill="#B2B2B2"
                    fillOpacity={0.23}
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="PS">
          <g id="PS_2">
            <g id="Rectangle 17" filter="url(#filter3_d_PELVICLYMPHNODE)">
              <rect
                x={467.05}
                y={313.42}
                width={89.1105}
                height={133.142}
                rx={8}
                fill="white"
              />
            </g>
            <path
              id="PS_3"
              d="M510.894 375.554C510.894 376.598 510.534 377.468 509.814 378.164C509.106 378.848 508.02 379.19 506.556 379.19H504.144V384.428H502.506V371.882H506.556C507.972 371.882 509.046 372.224 509.778 372.908C510.522 373.592 510.894 374.474 510.894 375.554ZM506.556 377.84C507.468 377.84 508.14 377.642 508.572 377.246C509.004 376.85 509.22 376.286 509.22 375.554C509.22 374.006 508.332 373.232 506.556 373.232H504.144V377.84H506.556ZM516.907 384.554C516.079 384.554 515.335 384.41 514.675 384.122C514.027 383.822 513.517 383.414 513.145 382.898C512.773 382.37 512.581 381.764 512.569 381.08H514.315C514.375 381.668 514.615 382.166 515.035 382.574C515.467 382.97 516.091 383.168 516.907 383.168C517.687 383.168 518.299 382.976 518.743 382.592C519.199 382.196 519.427 381.692 519.427 381.08C519.427 380.6 519.295 380.21 519.031 379.91C518.767 379.61 518.437 379.382 518.041 379.226C517.645 379.07 517.111 378.902 516.439 378.722C515.611 378.506 514.945 378.29 514.441 378.074C513.949 377.858 513.523 377.522 513.163 377.066C512.815 376.598 512.641 375.974 512.641 375.194C512.641 374.51 512.815 373.904 513.163 373.376C513.511 372.848 513.997 372.44 514.621 372.152C515.257 371.864 515.983 371.72 516.799 371.72C517.975 371.72 518.935 372.014 519.679 372.602C520.435 373.19 520.861 373.97 520.957 374.942H519.157C519.097 374.462 518.845 374.042 518.401 373.682C517.957 373.31 517.369 373.124 516.637 373.124C515.953 373.124 515.395 373.304 514.963 373.664C514.531 374.012 514.315 374.504 514.315 375.14C514.315 375.596 514.441 375.968 514.693 376.256C514.957 376.544 515.275 376.766 515.647 376.922C516.031 377.066 516.565 377.234 517.249 377.426C518.077 377.654 518.743 377.882 519.247 378.11C519.751 378.326 520.183 378.668 520.543 379.136C520.903 379.592 521.083 380.216 521.083 381.008C521.083 381.62 520.921 382.196 520.597 382.736C520.273 383.276 519.793 383.714 519.157 384.05C518.521 384.386 517.771 384.554 516.907 384.554Z"
              fill="#686868"
            />
          </g>
        </g>
        <g id="EIL">
          <g id="EIL_2">
            <g id="Rectangle 29" filter="url(#filter4_d_PELVICLYMPHNODE)">
              <rect
                width={49.9234}
                height={114.325}
                rx={8}
                transform="matrix(-0.937687 0.347481 0.319395 0.947622 691.24 329.225)"
                fill="white"
              />
            </g>
            <path
              id="EIL_3"
              d="M676.947 387.205V391.399H681.519V392.749H676.947V397.069H682.059V398.419H675.309V385.855H682.059V387.205H676.947ZM686.176 385.873V398.419H684.538V385.873H686.176ZM690.605 397.087H694.997V398.419H688.967V385.873H690.605V397.087Z"
              fill="#686868"
            />
          </g>
        </g>
        <g id="EIR">
          <g id="EIR_2">
            <g id="Rectangle 29_2" filter="url(#filter5_d_PELVICLYMPHNODE)">
              <rect
                width={49.9234}
                height={114.325}
                rx={8}
                transform="matrix(0.937687 0.347481 -0.319395 0.947622 332.76 329.225)"
                fill="white"
              />
            </g>
            <path
              id="EIR_3"
              d="M326.648 387.205V391.399H331.22V392.749H326.648V397.069H331.76V398.419H325.01V385.855H331.76V387.205H326.648ZM335.876 385.873V398.419H334.238V385.873H335.876ZM345.274 398.419L342.286 393.289H340.306V398.419H338.668V385.873H342.718C343.666 385.873 344.464 386.035 345.112 386.359C345.772 386.683 346.264 387.121 346.588 387.673C346.912 388.225 347.074 388.855 347.074 389.563C347.074 390.427 346.822 391.189 346.318 391.849C345.826 392.509 345.082 392.947 344.086 393.163L347.236 398.419H345.274ZM340.306 391.975H342.718C343.606 391.975 344.272 391.759 344.716 391.327C345.16 390.883 345.382 390.295 345.382 389.563C345.382 388.819 345.16 388.243 344.716 387.835C344.284 387.427 343.618 387.223 342.718 387.223H340.306V391.975Z"
              fill="#686868"
            />
          </g>
        </g>
        <g id="OBR">
          <g id="OBR_2">
            <g id="Rectangle 18" filter="url(#filter6_d_PELVICLYMPHNODE)">
              <rect
                x={387.374}
                y={471.723}
                width={82.8204}
                height={67.095}
                rx={8}
                fill="white"
              />
            </g>
            <path
              id="OBR_3"
              d="M417.787 511.72C416.623 511.72 415.561 511.45 414.601 510.91C413.641 510.358 412.879 509.596 412.315 508.624C411.763 507.64 411.487 506.536 411.487 505.312C411.487 504.088 411.763 502.99 412.315 502.018C412.879 501.034 413.641 500.272 414.601 499.732C415.561 499.18 416.623 498.904 417.787 498.904C418.963 498.904 420.031 499.18 420.991 499.732C421.951 500.272 422.707 501.028 423.259 502C423.811 502.972 424.087 504.076 424.087 505.312C424.087 506.548 423.811 507.652 423.259 508.624C422.707 509.596 421.951 510.358 420.991 510.91C420.031 511.45 418.963 511.72 417.787 511.72ZM417.787 510.298C418.663 510.298 419.449 510.094 420.145 509.686C420.853 509.278 421.405 508.696 421.801 507.94C422.209 507.184 422.413 506.308 422.413 505.312C422.413 504.304 422.209 503.428 421.801 502.684C421.405 501.928 420.859 501.346 420.163 500.938C419.467 500.53 418.675 500.326 417.787 500.326C416.899 500.326 416.107 500.53 415.411 500.938C414.715 501.346 414.163 501.928 413.755 502.684C413.359 503.428 413.161 504.304 413.161 505.312C413.161 506.308 413.359 507.184 413.755 507.94C414.163 508.696 414.715 509.278 415.411 509.686C416.119 510.094 416.911 510.298 417.787 510.298ZM432.532 505.132C432.988 505.204 433.402 505.39 433.774 505.69C434.158 505.99 434.458 506.362 434.674 506.806C434.902 507.25 435.016 507.724 435.016 508.228C435.016 508.864 434.854 509.44 434.53 509.956C434.206 510.46 433.732 510.862 433.108 511.162C432.496 511.45 431.77 511.594 430.93 511.594H426.25V499.048H430.75C431.602 499.048 432.328 499.192 432.928 499.48C433.528 499.756 433.978 500.134 434.278 500.614C434.578 501.094 434.728 501.634 434.728 502.234C434.728 502.978 434.524 503.596 434.116 504.088C433.72 504.568 433.192 504.916 432.532 505.132ZM427.888 504.466H430.642C431.41 504.466 432.004 504.286 432.424 503.926C432.844 503.566 433.054 503.068 433.054 502.432C433.054 501.796 432.844 501.298 432.424 500.938C432.004 500.578 431.398 500.398 430.606 500.398H427.888V504.466ZM430.786 510.244C431.602 510.244 432.238 510.052 432.694 509.668C433.15 509.284 433.378 508.75 433.378 508.066C433.378 507.37 433.138 506.824 432.658 506.428C432.178 506.02 431.536 505.816 430.732 505.816H427.888V510.244H430.786ZM443.895 511.594L440.907 506.464H438.927V511.594H437.289V499.048H441.339C442.287 499.048 443.085 499.21 443.733 499.534C444.393 499.858 444.885 500.296 445.209 500.848C445.533 501.4 445.695 502.03 445.695 502.738C445.695 503.602 445.443 504.364 444.939 505.024C444.447 505.684 443.703 506.122 442.707 506.338L445.857 511.594H443.895ZM438.927 505.15H441.339C442.227 505.15 442.893 504.934 443.337 504.502C443.781 504.058 444.003 503.47 444.003 502.738C444.003 501.994 443.781 501.418 443.337 501.01C442.905 500.602 442.239 500.398 441.339 500.398H438.927V505.15Z"
              fill="#686868"
            />
          </g>
        </g>
        <g id="OBL">
          <g id="OBL_2">
            <g id="Rectangle 24" filter="url(#filter7_d_PELVICLYMPHNODE)">
              <rect
                width={84.9171}
                height={67.095}
                rx={8}
                transform="matrix(-1 0 0 1 636.859 471.177)"
                fill="white"
              />
            </g>
            <path
              id="OBL_3"
              d="M584.995 511.174C583.831 511.174 582.769 510.904 581.809 510.364C580.849 509.812 580.087 509.05 579.523 508.078C578.971 507.094 578.695 505.99 578.695 504.766C578.695 503.542 578.971 502.444 579.523 501.472C580.087 500.488 580.849 499.726 581.809 499.186C582.769 498.634 583.831 498.358 584.995 498.358C586.171 498.358 587.239 498.634 588.199 499.186C589.159 499.726 589.915 500.482 590.467 501.454C591.019 502.426 591.295 503.53 591.295 504.766C591.295 506.002 591.019 507.106 590.467 508.078C589.915 509.05 589.159 509.812 588.199 510.364C587.239 510.904 586.171 511.174 584.995 511.174ZM584.995 509.752C585.871 509.752 586.657 509.548 587.353 509.14C588.061 508.732 588.613 508.15 589.009 507.394C589.417 506.638 589.621 505.762 589.621 504.766C589.621 503.758 589.417 502.882 589.009 502.138C588.613 501.382 588.067 500.8 587.371 500.392C586.675 499.984 585.883 499.78 584.995 499.78C584.107 499.78 583.315 499.984 582.619 500.392C581.923 500.8 581.371 501.382 580.963 502.138C580.567 502.882 580.369 503.758 580.369 504.766C580.369 505.762 580.567 506.638 580.963 507.394C581.371 508.15 581.923 508.732 582.619 509.14C583.327 509.548 584.119 509.752 584.995 509.752ZM599.74 504.586C600.196 504.658 600.61 504.844 600.982 505.144C601.366 505.444 601.666 505.816 601.882 506.26C602.11 506.704 602.224 507.178 602.224 507.682C602.224 508.318 602.062 508.894 601.738 509.41C601.414 509.914 600.94 510.316 600.316 510.616C599.704 510.904 598.978 511.048 598.138 511.048H593.458V498.502H597.958C598.81 498.502 599.536 498.646 600.136 498.934C600.736 499.21 601.186 499.588 601.486 500.068C601.786 500.548 601.936 501.088 601.936 501.688C601.936 502.432 601.732 503.05 601.324 503.542C600.928 504.022 600.4 504.37 599.74 504.586ZM595.096 503.92H597.85C598.618 503.92 599.212 503.74 599.632 503.38C600.052 503.02 600.262 502.522 600.262 501.886C600.262 501.25 600.052 500.752 599.632 500.392C599.212 500.032 598.606 499.852 597.814 499.852H595.096V503.92ZM597.994 509.698C598.81 509.698 599.446 509.506 599.902 509.122C600.358 508.738 600.586 508.204 600.586 507.52C600.586 506.824 600.346 506.278 599.866 505.882C599.386 505.474 598.744 505.27 597.94 505.27H595.096V509.698H597.994ZM606.135 509.716H610.527V511.048H604.497V498.502H606.135V509.716Z"
              fill="#686868"
            />
          </g>
        </g>
        <g id="IIL">
          <g id="IIL_2">
            <g id="Rectangle 27" filter="url(#filter8_d_PELVICLYMPHNODE)">
              <rect
                width={37.6473}
                height={92.4563}
                rx={8}
                transform="matrix(-0.982638 -0.185532 -0.169252 0.985573 643.645 370.241)"
                fill="white"
              />
            </g>
            <path
              id="IIL_3"
              d="M612.033 405.781V418.327H610.395V405.781H612.033ZM616.463 405.781V418.327H614.825V405.781H616.463ZM620.892 416.995H625.284V418.327H619.254V405.781H620.892V416.995Z"
              fill="#686868"
            />
          </g>
        </g>
        <g id="IIR">
          <g id="IIR_2">
            <g id="Rectangle 22" filter="url(#filter9_d_PELVICLYMPHNODE)">
              <rect
                width={37.6473}
                height={92.4563}
                rx={8}
                transform="matrix(0.982638 -0.185532 0.169252 0.985573 380.225 370.241)"
                fill="white"
              />
            </g>
            <path
              id="IIR_3"
              d="M400.396 405.781V418.327H398.758V405.781H400.396ZM404.826 405.781V418.327H403.188V405.781H404.826ZM414.223 418.327L411.235 413.197H409.255V418.327H407.617V405.781H411.667C412.615 405.781 413.413 405.943 414.061 406.267C414.721 406.591 415.213 407.029 415.537 407.581C415.861 408.133 416.023 408.763 416.023 409.471C416.023 410.335 415.771 411.097 415.267 411.757C414.775 412.417 414.031 412.855 413.035 413.071L416.185 418.327H414.223ZM409.255 411.883H411.667C412.555 411.883 413.221 411.667 413.665 411.235C414.109 410.791 414.331 410.203 414.331 409.471C414.331 408.727 414.109 408.151 413.665 407.743C413.233 407.335 412.567 407.131 411.667 407.131H409.255V411.883Z"
              fill="#686868"
            />
          </g>
        </g>
      </g>
      <g id="Metastases">
        {Object.keys(metastases).map((key) => (
          <circle
            key={key}
            id={key}
            cx={(metastases[key] as Coordinates).x}
            cy={(metastases[key] as Coordinates).y}
            r={15}
            fill={(metastases[key] as Coordinates).color || markerColor}
            fillOpacity={0.5}
            onClick={onMetastasisClick}
            onContextMenu={onContextMenu}
          />
        ))}
      </g>
      <defs>
        <filter
          id="filter0_f_PELVICLYMPHNODE"
          x={138.015}
          y={-72.097}
          width={747.969}
          height={911.493}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={8.0485}
            result="effect1_foregroundBlur_PELVICLYMPHNODE"
          />
        </filter>
        <filter
          id="filter1_f_PELVICLYMPHNODE"
          x={198.493}
          y={125.851}
          width={639.588}
          height={560.177}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={8.0485}
            result="effect1_foregroundBlur_PELVICLYMPHNODE"
          />
        </filter>
        <filter
          id="filter2_f_PELVICLYMPHNODE"
          x={265.341}
          y={-37.1663}
          width={505.892}
          height={749.476}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={8.58507}
            result="effect1_foregroundBlur_PELVICLYMPHNODE"
          />
        </filter>
        <filter
          id="filter3_d_PELVICLYMPHNODE"
          x={421.97}
          y={272.534}
          width={179.269}
          height={223.3}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.19344} />
          <feGaussianBlur stdDeviation={22.5397} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PELVICLYMPHNODE"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PELVICLYMPHNODE"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_PELVICLYMPHNODE"
          x={601.478}
          y={290.623}
          width={169.227}
          height={211.275}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.19344} />
          <feGaussianBlur stdDeviation={22.5397} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PELVICLYMPHNODE"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PELVICLYMPHNODE"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_PELVICLYMPHNODE"
          x={253.295}
          y={290.623}
          width={169.227}
          height={211.275}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.19344} />
          <feGaussianBlur stdDeviation={22.5397} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PELVICLYMPHNODE"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PELVICLYMPHNODE"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_PELVICLYMPHNODE"
          x={342.294}
          y={430.837}
          width={172.979}
          height={157.254}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.19344} />
          <feGaussianBlur stdDeviation={22.5397} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PELVICLYMPHNODE"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PELVICLYMPHNODE"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_PELVICLYMPHNODE"
          x={506.863}
          y={430.291}
          width={175.076}
          height={157.254}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.19344} />
          <feGaussianBlur stdDeviation={22.5397} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PELVICLYMPHNODE"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PELVICLYMPHNODE"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_PELVICLYMPHNODE"
          x={547.16}
          y={323.714}
          width={140.327}
          height={185.577}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.19344} />
          <feGaussianBlur stdDeviation={22.5397} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PELVICLYMPHNODE"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PELVICLYMPHNODE"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d_PELVICLYMPHNODE"
          x={336.382}
          y={323.714}
          width={140.327}
          height={185.577}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.19344} />
          <feGaussianBlur stdDeviation={22.5397} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PELVICLYMPHNODE"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PELVICLYMPHNODE"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
);

export default PelvicLymphNodeMetastasesImage;
